import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { getFTTBServiceIsEnabled } from 'pages/Internet/store/selectors';
import { getFTTBServiceDisconnectRequestId } from 'pages/Internet/store/selectors/servicesSelectors';
import { SuccessDisconnectStatus } from '../../../../components';

export const ServiceDisconnectSuccessStatus = compose(
  connect((state) => ({
    id: getFTTBServiceDisconnectRequestId(state),
    shouldRender: getFTTBServiceIsEnabled(state) && !!getFTTBServiceDisconnectRequestId(state),
  })),
  withRenderFlag,
)(SuccessDisconnectStatus);
